import axios from 'axios';

import apiConstants from './constants/api-constants';
import Helpers from '../common/helpers';

class B2BApi {
  static getKeys() {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.b2b_routes.get_keys);

    return axios(request);
  }

  static generateKey() {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.b2b_routes.generate_key, {});

    return axios(request);
  }

  static deactivateKey(key) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.b2b_routes.deactivate_key, {
      api_key: key,
    });

    return axios(request);
  }

  static revealApiSecret(key) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, `b2b/${key}/api_secret`);

    return axios(request);
  }
}

export default B2BApi;



// WEBPACK FOOTER //
// ./src/api/b2b-api.js